<div id="wrapper">
    <video autoplay muted loop #backgroundVideo>
      <source src="./assets/videos/JRE-videopressbg.mp4" type="video/mp4">
    </video>
    <!-- container -->
    <div nz-row class="container">
      <!-- header -->
      <div nz-col nzSpan="24">
        <div nz-row nzType="flex" nzJustify="center" nzAlign="middle" class="header">
          <div id="logo-right" nz-col nzSpan="10">
            <!-- <img src="./assets/images/fm6elogowhite.png" /> -->
          </div>
          <div id="logo-left" nz-col nzSpan="10">
            <!-- <img src="./assets/images/logo.png" /> -->
          </div>
        </div>
      </div>
      <!-- section -->
      <div nz-col nzSpan="24" class="section">
        <div nz-row nzType="flex" nzJustify="center" nzAlign="middle" class="section-title">
          <div nz-col nzXs="24" nzMd="12" nzXl="8" nzXXl="6" class="section-col">
            المشاركة في مباراة الصحفيون الشباب من أجل البيئة  2020-2021
          </div>
          <div nz-col nzXs="24" nzMd="8" nzXl="12" nzXXl="14" class="align-left section-col">
            <button nz-button nzType="primary" nzSize="large" class="button large">الريبورتاج الصحفي</button>
          </div>
        </div>
      </div>
      <!-- form -->
      <div nz-col nzSpan="24" id="form-container">
        <form nz-form [nzLayout]="'inline'" [formGroup]="validateForm" (ngSubmit)="submitForm()">
          <!-- form part 1 -->
          <div nz-row nzType="flex" nzJustify="center" nzAlign="middle">
            <div nz-col nzSpan="20" class="form">
              <h1 class="form-title"><img src="./assets/images/1.svg" class="ellipse" /> معلومات عامة</h1>
              <div nz-row nzGutter="12">
                <div nz-col nzLg="8" nzXs="24">
                  <nz-form-item nzFlex>
                    <nz-form-control [nzErrorTip]="getErrorTip('academy')">
                      <nz-select formControlName="academy" nzSize="large" [ngClass]="getClass('academy')" [nzOpen]="academy.open" #academy>
                        <nz-option
                          *ngFor="let academy of formData.getAcademyList()"
                          [nzLabel]="academy"
                          [nzValue]="academy"
                        ></nz-option>
                      </nz-select>
                      <span class="placeholder" (click)="academy.open = true">الأكاديمية <span class="required">*</span></span>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col nzLg="8" nzXs="24">
                  <nz-form-item nzFlex>
                    <nz-form-control [nzErrorTip]="getErrorTip('direction')">
                      <nz-select formControlName="direction" nzSize="large" [ngClass]="getClass('direction')" [nzOpen]="direction.open" #direction>
                        <nz-option
                          *ngFor="let academy of formData.getDirectionList(validateForm.get('academy').value)"
                          [nzLabel]="academy"
                          [nzValue]="academy"
                        ></nz-option>
                      </nz-select>
                      <span class="placeholder" (click)="direction.open = true">المديرية الاقليمية <span class="required">*</span></span>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col nzLg="8" nzXs="24">
                  <nz-form-item nzFlex>
                    <nz-form-control [nzErrorTip]="getErrorTip('institute')">
                      <nz-input-group class="form-input" nzSize="large">
                        <input nz-input nzBlock formControlName="institute" [ngClass]="getClass('institute')" #institute />
                        <span class="placeholder" (click)="institute.focus()">المؤسسة <span class="required">*</span></span>
                      </nz-input-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>
              <div nz-row nzGutter="12">
                <div nz-col nzLg="8" nzXs="24">
                  <nz-form-item nzFlex>
                    <nz-form-control [nzErrorTip]="getErrorTip('website')">
                      <nz-input-group class="form-input" nzSize="large">
                        <input nz-input nzBlock formControlName="website" [ngClass]="getClass('website')" #website />
                        <span class="placeholder" (click)="website.focus()">الموقع على الإنترنت</span>
                      </nz-input-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col nzLg="8" nzXs="24">
                  <nz-form-item nzFlex>
                    <nz-form-control [nzErrorTip]="getErrorTip('phone')">
                      <nz-input-group class="form-input" nzSize="large">
                        <input nz-input nzBlock formControlName="phone" [ngClass]="getClass('phone')" #phone />
                        <span class="placeholder" (click)="phone.focus()">الهاتف-الفاكس-البريد الإلكتروني</span>
                      </nz-input-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col nzLg="8" nzXs="24">
                  <nz-form-item nzFlex>
                    <nz-form-control [nzErrorTip]="getErrorTip('club')">
                      <nz-input-group class="form-input" nzSize="large">
                        <input nz-input formControlName="club" [ngClass]="getClass('club')" #club />
                        <span class="placeholder" (click)="club.focus()">اسم  النادي</span>
                      </nz-input-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>
              <div nz-row nzGutter="12">
                <div nz-col nzSpan="24">
                  <h3 class="form-subtitle">السنوات التي شاركت أو فازت المؤسسة في المباراة</h3>
                </div>
              </div>
              <div nz-row nzGutter="12">
                <div nz-col nzLg="8" nzXs="24">
                  <nz-form-item nzFlex>
                    <nz-form-control [nzErrorTip]="getErrorTip('participationYears')">
                      <nz-select nzMode="multiple" nzSize="large" formControlName="participationYears" [ngClass]="getClass('participationYears', validateForm, participationYears)" [nzOpen]="participationYears.open" #participationYears>
                        <nz-option *ngFor="let year of formData.getYears()" [nzLabel]="year" [nzValue]="year"></nz-option>
                      </nz-select>
                      <span class="placeholder" (click)="participationYears.open = true">المشاركة <span class="required">*</span></span>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col nzLg="8" nzXs="24">
                  <nz-form-item nzFlex>
                    <nz-form-control [nzErrorTip]="getErrorTip('winYears')">
                      <nz-select nzMode="multiple" nzSize="large" formControlName="winYears" [ngClass]="getClass('winYears', validateForm, winYears)" [nzOpen]="winYears.open" #winYears>
                        <nz-option *ngFor="let year of formData.getYears()" [nzLabel]="year" [nzValue]="year"></nz-option>
                      </nz-select>
                      <span class="placeholder" (click)="winYears.open = true">الفوز</span>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>
            </div>
          </div>
          <!-- form part 2 -->
          <div nz-row nzType="flex" nzJustify="center" nzAlign="middle">
            <div nz-col nzSpan="20" class="form">
              <h1 class="form-title"><img src="./assets/images/2.svg" class="ellipse" /> معلومات عن المشاركين</h1>
              <div nz-row nzGutter="12">
                <div nz-col nzSpan="24">
                  <h3 class="form-subtitle">فئة التلاميذ المشاركون</h3>
                </div>
              </div>
              <div nz-row nzGutter="12">
                <div nz-col nzSpan="24" class="margin-bottom-10">
                  <nz-form-item nzFlex>
                    <nz-form-control [nzErrorTip]="getErrorTip('studentCategory')">
                      <nz-radio-group formControlName="studentCategory" nzButtonStyle="solid" nzSize="large">
                        <label nz-radio-button nzValue="11-14">11 - 14 سنة</label>
                        <label nz-radio-button nzValue="15-18">15 - 18 سنة</label>
                        <label nz-radio-button nzValue="19-21">19 - 21 سنة</label>
                      </nz-radio-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>
              <ng-container formArrayName="students" *ngFor="let student of getStudents().controls; let i = index;">
                <div nz-row nzGutter="12" [formGroupName]="i">
                  <div nz-col nzLg="5" nzXs="24">
                    <nz-form-item nzFlex>
                      <nz-form-control [nzErrorTip]="getErrorTip('fullName', student)">
                        <nz-input-group class="form-input" nzSize="large">
                          <input nz-input nzBlock formControlName="fullName" [ngClass]="getClass('fullName', student)" #studentFullName />
                          <span class="placeholder" (click)="studentFullName.focus()">الإسم والنسب <span class="required">*</span></span>
                        </nz-input-group>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col nzLg="5" nzXs="24">
                    <nz-form-item nzFlex>
                      <nz-form-control [nzErrorTip]="getErrorTip('birthDate', student)">
                        <nz-date-picker nzSize="large" nzFormat="yyyy/MM/dd" nzPlaceHolder="" formControlName="birthDate" [ngClass]="getClass('birthDate', student)" #studentBirthDate></nz-date-picker>
                        <span class="placeholder" (click)="datePickerClick(studentBirthDate)">تاريخ  الازدياد</span>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col nzLg="5" nzXs="24">
                    <nz-form-item nzFlex>
                      <nz-form-control [nzErrorTip]="getErrorTip('level', student)">
                        <nz-input-group class="form-input" nzSize="large">
                          <input nz-input formControlName="level" [ngClass]="getClass('level', student)" #studentLevel />
                          <span class="placeholder" (click)="studentLevel.focus()">المستوى الدراسي</span>
                        </nz-input-group>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col nzLg="4" nzXs="24">
                    <nz-form-item nzFlex>
                      <nz-form-control [nzErrorTip]="getErrorTip('phone', student)">
                        <nz-input-group class="form-input" nzSize="large">
                          <input nz-input formControlName="phone" [ngClass]="getClass('phone', student)" #studentPhone />
                          <span class="placeholder" (click)="studentPhone.focus()">الهاتف</span>
                        </nz-input-group>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div nz-col nzLg="5" nzXs="24">
                    <nz-form-item nzFlex>
                      <nz-form-control [nzErrorTip]="getErrorTip('email', student)">
                        <nz-input-group class="form-input" nzSize="large">
                          <input nz-input formControlName="email" [ngClass]="getClass('email', student)" #studentEmail />
                          <span class="placeholder" (click)="studentEmail.focus()">البريد الإلكتروني</span>
                        </nz-input-group>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                </div>
              </ng-container>
              <div nz-row nzGutter="12">
                <div nz-col nzSpan="24">
                  <button *ngIf="getStudents().length < 6" nz-button nzType="link" (click)="addStudent($event)" style="color: #20cd87 !important;"><i nz-icon nzType="plus-square" nzTheme="outline"></i>&nbsp;&nbsp;إضافة تلميذ</button>
                  <button *ngIf="getStudents().length > 1" nz-button nzType="link" (click)="removeStudent($event)" style="color: #20cd87 !important;"><i nz-icon nzType="minus-square" nzTheme="outline"></i>&nbsp;&nbsp;حذف</button>
                </div>
              </div>
            </div>
          </div>
          <!-- form part 3 -->
          <div nz-row nzType="flex" nzJustify="center" nzAlign="middle">
            <div nz-col nzSpan="20" class="form">
              <h1 class="form-title"><img src="./assets/images/3.svg" class="ellipse" /> معلومات عن المؤطر(ة)</h1>
              <div nz-row nzGutter="12" formGroupName="teacher">
                <div nz-col nzLg="6" nzXs="24">
                  <nz-form-item nzFlex>
                    <nz-form-control [nzErrorTip]="getErrorTip('fullNameAr', validateForm.get('teacher'))">
                      <nz-input-group class="form-input" nzSize="large">
                        <input nz-input formControlName="fullNameAr" [ngClass]="getClass('fullNameAr', validateForm.get('teacher'))" #teacherFullNameAr />
                        <span class="placeholder" (click)="teacherFullNameAr.focus()">اسم الأستاد(ة) المؤطر(ة) بالعربية <span class="required">*</span></span>
                      </nz-input-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col nzLg="6" nzXs="24">
                  <nz-form-item nzFlex>
                    <nz-form-control [nzErrorTip]="getErrorTip('fullNameFr', validateForm.get('teacher'))">
                      <nz-input-group class="form-input" nzSize="large">
                        <input nz-input formControlName="fullNameFr" [ngClass]="getClass('fullNameFr', validateForm.get('teacher'))" #teacherFullNameFr />
                        <span class="placeholder" (click)="teacherFullNameFr.focus()">اسم الأستاد(ة) المؤطر(ة) بالفرنسية <span class="required">*</span></span>
                      </nz-input-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col nzLg="6" nzXs="24">
                  <nz-form-item nzFlex>
                    <nz-form-control [nzErrorTip]="getErrorTip('subjectOfSpecialisation', validateForm.get('teacher'))">
                      <nz-input-group class="form-input" nzSize="large">
                        <input nz-input formControlName="subjectOfSpecialisation" [ngClass]="getClass('subjectOfSpecialisation', validateForm.get('teacher'))" #teacherSubjectOfSpecialisation />
                        <span class="placeholder" (click)="teacherSubjectOfSpecialisation.focus()">مادة التخصص</span>
                      </nz-input-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col nzLg="6" nzXs="24">
                  <nz-form-item nzFlex>
                    <nz-form-control [nzErrorTip]="getErrorTip('phone', validateForm.get('teacher'))">
                      <nz-input-group class="form-input" nzSize="large">
                        <input nz-input nzBlock formControlName="phone" [ngClass]="getClass('phone', validateForm.get('teacher'))" #teacherPhone />
                        <span class="placeholder" (click)="teacherPhone.focus()">الهاتف-الفاكس-البريد الإلكتروني</span>
                      </nz-input-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>
              <div nz-row nzGutter="12">
                <div nz-col nzSpan="24">
                  <h3 class="form-subtitle">نشكرك على ذكر صلة عملك بالأهداف 17 للتنمية المستدامة <span class="required">*</span></h3>
                </div>
              </div>
              <div nz-row nzGutter="12" formGroupName="objective">
                <div nz-col nzMd="8" nzXs="24">
                  <nz-form-item nzFlex>
                    <nz-form-control [nzErrorTip]="getErrorTip('number', validateForm.get('objective'))">
                      <nz-input-group class="form-input" nzSize="large">
                        <input nz-input nzBlock formControlName="number" [ngClass]="getClass('number', validateForm.get('objective'))" #objectiveNumber />
                        <span class="placeholder" (click)="objectiveNumber.focus()">رقم الهدف <span class="required">*</span></span>
                      </nz-input-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
                <div nz-col nzMd="16" nzXs="24">
                  <nz-form-item nzFlex>
                    <nz-form-control [nzErrorTip]="getErrorTip('justification', validateForm.get('objective'))">
                      <nz-input-group class="form-input" nzSize="large">
                        <input nz-input nzBlock formControlName="justification" [ngClass]="getClass('justification', validateForm.get('objective'))" #objectiveJustification />
                        <span class="placeholder" (click)="objectiveJustification.focus()">المرجو إعطاء تفسير <span class="required">*</span></span>
                      </nz-input-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>
            </div>
          </div>
          <!-- form part 4 -->
          <div nz-row nzType="flex" nzJustify="center" nzAlign="middle">
            <div nz-col nzSpan="20" class="form">
              <h1 class="form-title"><img src="./assets/images/4.svg" class="ellipse" />بطاقة الصورة</h1>
              <div nz-row nzType="flex" nzJustify="center">
                <div nz-col nzLg="12" nzXs="24">
                  <nz-form-item nzFlex>
                    <nz-form-control [nzErrorTip]="getErrorTip('articleTitle')">
                      <nz-input-group class="form-input" nzSize="large">
                        <input nz-input nzBlock formControlName="articleTitle" [ngClass]="getClass('articleTitle')" #articleTitle />
                        <span class="placeholder" (click)="articleTitle.focus()">عنوان التحقيق الصحفي<span class="required">*</span></span>
                      </nz-input-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>
              <div nz-row nzType="flex" nzJustify="center">
                <div nz-col nzLg="12" nzXs="24">
                  <nz-form-item nzFlex>
                    <nz-form-control [nzErrorTip]="getErrorTip('doc')">
                      <input type="hidden" formControlName="doc" value="" />
                      <!-- <div class="clearfix" > -->
                        <nz-upload style="direction:ltr !important;"
                          nzType="drag"
                          [nzDisabled]="contImage.length >= 1"
                          [nzShowButton]="contImage.length == 0"
                          [nzLimit]="1"
                          nzAction="#"
                          [nzCustomRequest]="uploadImage"
                          (nzChange)="handleChange($event)"
                        >
                          <p class="ant-upload-drag-icon">
                            <i nz-icon nzType="cloud-upload" nzTheme="outline"></i>
                          </p>
                          <p class="ant-upload-text">أنقر أو إسحب وأسقط الملف هنا</p>
                          <p class="ant-upload-hint">
                            pdf, doc, docx, ppt (3) صفحات على الأكثر
                          </p>
                        </nz-upload>
                        <!-- <nz-upload
                          nzAction="#"
                          [nzCustomRequest]="uploadImage"
                          nzAccept="image/*"
                          nzListType="picture-card"
                          [(nzFileList)]="imagesList"
                          [nzShowButton]="imagesList.length < 1"
                          [nzShowUploadList]="showImagesUploadList"
                          [nzPreview]="handleImagePreview"
                          (nzChange)="handleImagesChange($event)"
                          [nzRemove]="removeImage"
                        >
                          <i nz-icon nzType="plus"></i>
                          <div class="ant-upload-text">تحميل</div>
                        </nz-upload>
                        <nz-modal
                          [nzVisible]="isImagePreviewVisible"
                          [nzContent]="modalContent"
                          [nzFooter]="null"
                          (nzOnCancel)="isImagePreviewVisible = false"
                        >
                          <ng-template #modalContent>
                            <img [src]="imagePreview" [ngStyle]="{ width: '100%' }" />
                          </ng-template>
                        </nz-modal> 
                      </div> -->
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>
              <!-- <div nz-row nzType="flex" nzJustify="center">
                <div nz-col nzLg="12" nzXs="24">
                  <nz-form-item nzFlex class="no-margin">
                    <nz-form-control [nzErrorTip]="getErrorTip('videoLink')">
                      <nz-input-group class="form-input" nzSize="large">
                        <input nz-input nzBlock formControlName="videoLink" [ngClass]="getClass('videoLink')" (keyup)="videoLinkKeyup.next($event)" #videoLink />
                        <span class="placeholder" (click)="videoLink.focus()">رابط الفيديو <span class="required">*</span></span>
                      </nz-input-group>
                    </nz-form-control>
                  </nz-form-item>
                  <div nz-row nzGutter="12" [ngClass]="{'no-margin': !isVideoLinkPreviewLoading }">
                    <div nz-col nzSpan="24">
                      <nz-skeleton [nzLoading]="isVideoLinkPreviewLoading" [nzActive]="true" [ngClass]="{'not-is-loading': !isVideoLinkPreviewLoading}">
                        <app-video-preview *ngIf="videoPreviewData" [data]="videoPreviewData" (onValidation)="isVideoLinkValid = $event"></app-video-preview>
                      </nz-skeleton>
                    </div>
                  </div>
                  <nz-alert nzType="warning" [nzMessage]="videoLinkAlertTpl" nzShowIcon class="margin-top-20">
                    <ng-template #videoLinkAlertTpl>
                      <span class="alert-text">
                         يمكنك فقط نسخ روابط youtube إلى حقل الإدخال
                        <br>
                        يجب ان لا تزيد مدة مقطع الفيديو عن 3 دقائق بما في ذلك قائمة المصادر المعتمدة 
                      </span>
                    </ng-template>
                  </nz-alert>
                </div>
              </div> -->
            </div>
          </div>
          <!-- form part 5 -->
          <div nz-row nzType="flex" nzJustify="center" nzAlign="middle">
            <div nz-col nzSpan="20" class="form">
              <h1 class="form-title"><img src="./assets/images/5.svg" class="ellipse" /> وسائل النشر</h1>
              <div nz-row nzType="flex" nzJustify="center">
                <div nz-col nzLg="12" nzXs="24">
                  <h3 class="form-subtitle" style="text-align: center">يجب تحميل 3 صور على الأقل</h3>
                </div>
              </div>
              <div nz-row nzType="flex" nzJustify="center">
                <div nz-col nzLg="12" nzXs="24">
                  <nz-form-item nzFlex>
                    <nz-form-control [nzErrorTip]="getErrorTip('images')">
                      <input type="hidden" formControlName="images" value="" />
                      <div class="clearfix">
                        <nz-upload
                          nzAction="#"
                          [nzCustomRequest]="uploadImages"
                          nzAccept="image/*"
                          nzListType="picture-card"
                          [(nzFileList)]="imagesList"
                          [nzShowButton]="imagesList.length < 3"
                          [nzShowUploadList]="showImagesUploadList"
                          [nzPreview]="handleImagePreview"
                          (nzChange)="handleImagesChange($event)"
                          [nzRemove]="removeImage"
                        >
                          <i nz-icon nzType="plus"></i>
                          <div class="ant-upload-text">تحميل</div>
                        </nz-upload>
                        <nz-modal
                          [nzVisible]="isImagePreviewVisible"
                          [nzContent]="modalContent"
                          [nzFooter]="null"
                          (nzOnCancel)="isImagePreviewVisible = false"
                        >
                          <ng-template #modalContent>
                            <img [src]="imagePreview" [ngStyle]="{ width: '100%' }" />
                          </ng-template>
                        </nz-modal>
                      </div>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>
            </div>
          </div>
          <!-- form part 6 -->
          <div nz-row nzType="flex" nzJustify="center" nzAlign="middle">
            <div nz-col nzSpan="20" class="form">
              <h1 class="form-title"><img src="./assets/images/6.svg" class="ellipse" /> الرمز الخاص بمدير الثانوية</h1>
              <div nz-row nzType="flex" nzJustify="center">
                <div nz-col nzLg="12" nzXs="24">
                  <h3 class="form-subtitle">يعوض رمز GRESA الخاص بمدير الثانوية توقيعه وختمه</h3>
                </div>
              </div>
              <div nz-row nzType="flex" nzJustify="center">
                <div nz-col nzLg="12" nzXs="24">
                  <nz-form-item nzFlex>
                    <nz-form-control [nzErrorTip]="getErrorTip('codeGresa')">
                      <nz-input-group class="form-input" nzSize="large">
                        <input nz-input nzBlock formControlName="codeGresa" [ngClass]="getClass('codeGresa')" #codeGresa />
                        <span class="placeholder" (click)="codeGresa.focus()">الرمز (GRESA) <span class="required">*</span></span>
                      </nz-input-group>
                    </nz-form-control>
                  </nz-form-item>
                </div>
              </div>
            </div>
          </div>
          <!-- form submit -->
          <div nz-row nzType="flex" nzJustify="center" nzAlign="middle">
            <div nz-col nzSpan="20" class="form-submit">
              <button nz-button nzType="primary" nzSize="large" nzShape="round" class="button large">
                المشاركة<img src="./assets/images/share.svg" />
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  
  <ng-template #errorModalTpl>
    <div class="error-modal">
      <h2>! تنبيه</h2>
      <h3>يرجى التحقق من جميع الحقول قبل الإرسال</h3>
      <h4>لا يمكنك بعد ذلك تعديل أو حذف المشاركة </h4>
      <div class="margin-top-20">
        <button nz-button nzType="primary" nzSize="large" nzShape="round" class="button half" [class.disabled]="validateForm.invalid || isLoading" (click)="saveForm($event)" [disabled]="validateForm.invalid || isLoading">
          إرسال <i *ngIf="isLoading" nz-icon nzType="loading"></i>
        </button>
      </div>
      <div class="margin-top-10">
        <button nz-button nzType="link" nzSize="large" nzShape="round" class="cancel-button" (click)="errorModal.destroy()">
          <i nz-icon nzType="swap-left"></i>الرجوع إلى الإستمارة
        </button>
      </div>
    </div>
  </ng-template>
  <!-- <ng-template #errorModalTpll>
    <div class="error-modal">
      <h2>! تنبيه</h2>
      <h3>يرجى التحقق من جميع الحقول قبل الإرسال</h3>
      <h4>لا يمكنك بعد ذلك تعديل أو حذف المشاركة </h4>
      <div class="margin-top-20">
        <button nz-button nzType="primary" nzSize="large" nzShape="round" class="button half" [class.disabled]="validateForm.invalid || isLoading" (click)="saveForm($event)" [disabled]="validateForm.invalid || isLoading">
          إرسال <i *ngIf="isLoading" nz-icon nzType="loading"></i>
        </button>
      </div>
      <div class="margin-top-10">
        <button nz-button nzType="link" nzSize="large" nzShape="round" class="cancel-button" (click)="errorModale.destroy()">
          <i nz-icon nzType="swap-left"></i>الرجوع إلى الإستمارة
        </button>
      </div>
    </div>
  </ng-template> -->
  